import styled from "styled-components"

export const ValidationButtonContainer = styled.div`
  width: 150px;
  float: right;
  margin-top: auto;
`
